<template>
  <div class="search">
    <nav-header class="page-header">
      <template #title>
        <van-search
          v-model="searchValue"
          placeholder="请输入搜索关键词"
          show-action
          shape="round"
          background="#fff"
          @input="handleInput"
          @cancel="handleCancel"
        >
          <template #left-icon>
            <img
              class="search-ico"
              src="../../assets/img/knowledge-base/search.png"
              width="16"
            />
          </template>
        </van-search>
      </template>
    </nav-header>
    <div class="keywords" v-if="searchValue.length <= 0">
      <div class="history" v-if="this.historyList.length > 0">
        <h3>
          历史搜索
          <i class="ico-del" @click="handleDelHistory"
            ><img src="../../assets/img/knowledge-base/btn_del.png" width="18"
          /></i>
        </h3>
        <ul>
          <li
            v-for="(item, index) in historyList"
            @click="searchKeyword(item)"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="hot" v-if="this.hotList.length > 0">
        <h3>热门搜索</h3>
        <ul>
          <li
            v-for="item in hotList"
            :key="item.keywordId"
            @click="searchKeyword(item.keywordName)"
          >
            {{ item.keywordName }}
          </li>
        </ul>
      </div>
    </div>
    <div class="result-con" v-if="searchValue.length > 0">
      <van-loading type="spinner" v-if="loading" />

      <div class="result" v-if="!loading">
        <div class="list" v-if="resultList.length > 0">
          <ul>
            <li
              v-for="item in resultList"
              :key="item.questionId"
              v-html="item.questionName"
              @click="gotoDetail(item.questionId, item.questionName)"
            ></li>
          </ul>
        </div>
        <div class="empty" v-if="!resultList.length">
          <van-empty
            description="没有找到相关问题，请换个关键词试试，或关注万商服微信公众号进行留言"
            :image="path"
          />
        </div>
      </div>
      <div class="line" v-if="recommendList.length > 0 && !loading"></div>
      <div class="suggest" v-if="recommendList.length > 0 && !loading">
        <div class="notice">为您推荐</div>
        <template>
          <!-- <van-loading type="spinner" /> -->
        </template>
        <ul>
          <li
            v-for="item in recommendList"
            :key="item.questionId"
            v-html="item.questionName"
            @click="gotoDetail(item.questionId, item.questionName)"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from './navHeader.vue';
import { Dialog } from 'vant';
import path from '../../assets/img/knowledge-base/img_empty.png';
import {
  apiGetHotSearch,
  apiGetHistory,
  apiGetQuestionList,
  apiVlickHotSearch,
  apiClearHistory,
  apiGeRecommendList,
} from '@/api/knowledgeBase.js';
export default {
  name: 'knowledgeBase_search',
  components: {
    NavHeader,
  },
  computed: {
    userId() {
      return this.$store.state.account.userId;
    },
  },
  watch: {
    searchValue(val) {
      if (!val) {
        this.getHistoryList();
      }
    },
  },
  data() {
    return {
      path: path,
      searchValue: '',
      historyList: [],
      hotList: [],
      resultList: [],
      recommendList: [],
      loading: true,
    };
  },
  methods: {
    getHistoryList() {
      apiGetHistory().then((res) => {
        this.historyList = res;
      });
      // let history = localStorage.getItem('history');
      // this.historyList = history ? JSON.parse(history) : [];
    },
    getHotList() {
      apiGetHotSearch().then((res) => {
        this.hotList = res;
      });
    },

    handleInput(val) {
      if (val) {
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
          let data = {
            pageNum: 1,
            pageSize: 20,
            questionName: this.searchValue,
          };
          this.loading = true;
          this.resultList = []

          let { items: resultList } = await apiGetQuestionList(data);
          setTimeout(() => {
            this.loading = false;
          }, 20);

          resultList.map((el) => {
            el.questionName = el.questionName.replace(
              this.searchValue,
              '<span>' + this.searchValue + '</span>'
            );
            return el;
          });
          this.resultList = resultList;

          let data2 = {
            answer: this.searchValue,
            pageNum: 1,
            pageSize: 20,
            questionStatus: 1,
          };
          let { items: recommendList } = await apiGeRecommendList(data2);
          let newRecommendList = [];
          recommendList.forEach((recommend) => {
            if (
              !resultList.find(
                (result) => result.questionId == recommend.questionId
              )
            ) {
              newRecommendList.push(recommend);
            }
          });
          this.recommendList = newRecommendList;
        }, 300);
      }
    },
    handleCancel() {
      console.log('cancel');
    },
    handleDelHistory() {
      Dialog.confirm({
        message: '确认要清空历史搜索吗？',
        confirmButtonText: '确定',
      })
        .then(() => {
          apiClearHistory().then(() => {
            this.getHistoryList();
          });
        })
        .catch(() => {});
    },
    searchKeyword(name) {
      this.searchValue = name;
      this.handleInput(name);
    },

    gotoDetail(id, name, flag) {
      this.historyList.unshift({
        keywordId: '',
        keywordName: this.searchValue,
      });
      // localStorage.setItem('history', JSON.stringify(this.historyList));
      this.$router.push({
        path: '/knowledge/detail',
        query: {
          id,
        },
      });
      if (flag) {
        let data = {
          keywordId: id,
          userId: this.userId,
        };
        apiVlickHotSearch(data);
      }
    },
  },
  created() {
    this.getHotList();
    this.getHistoryList();
  },
};
</script>

<style lang="less">
.search {
  background-color: #ffffff;
  .search-ico {
    position: relative;
    vertical-align: sub;
  }
  .van-search {
    margin: 5px 12px 2px -120px;
    height: 32px;
    border-radius: 16px;
  }
  .van-icon {
    color: #aaa;
    margin-right: 0px;
  }
  .van-cell.van-cell--borderless.van-field {
    padding: 4px 0;
  }
  .van-search__content.van-search__content--round {
    border: 0;
    background: #f6f8f8;
  }
  .keywords {
    margin: 0 12px;
    text-align: left;
    color: #333;
    font-size: 14px;
    h3 {
      color: #111;
      font-size: 15px;
      line-height: 21px;
      padding: 20px 0 12px 0;
      margin: 0;
      .ico-del {
        float: right;
      }
    }
    ul {
      line-height: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      box-sizing: border-box;
    }
    li {
      min-width: 51px;
      padding: 0 12px;
      text-align: center;
      display: inline-block;
      background: #f3f5f6;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      margin: 0 12px 12px 0;
    }
  }
  .result-con {
    text-align: left;
    font-size: 14px;
    height: calc(~'100vh -  50px');
    display: flex;
    flex-direction: column;
    ul {
      overflow: auto;
      padding: 0 12px;
    }
    li {
      padding: 15px 0;
      border-bottom: 1px solid #f0f0f0;
      font-size: 14px;
      line-height: 20px;
    }
    .result {
      flex-shrink: 0;
      background-color: #fff;
      .list {
        ul {
          flex-shrink: 0;
          max-height: 400px;
          overflow: scroll;
        }
        li {
          color: #111111;

          span {
            color: #FF6F00;
          }
        }
      }
      .empty {
        height: 400px;
        display: flex;
        align-items: center;
        background: linear-gradient(180deg, #FFFFFF 0%, #F3F5F6 100%);
        .van-empty__image {
          width: 249px;
          height: 196px;
        }
        .van-empty__description {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #111111;
          line-height: 24px;
          text-align: center;
          margin-top: 40px;
        }
      }
    }
    .line {
      height: 12px;
      background-color: #f3f5f6;
      flex-shrink: 0;
    }
    .suggest {
      background-color: #ffffff;
      min-height: 200px;
      flex: 1;
      padding-top: 12px;

      .notice {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        padding-left: 12px;
      }
      ul {
        height: calc(~'100% -  30px');
        overflow: scroll;
      }
      li {
        color: #666666;
      }
    }
  }
  .van-loading {
    text-align: center;
  }
}
</style>